<template>
    <section class="min-h-screen flex items-stretch text-white bg-[#F7F7F7]">
      <!-- Side Menu -->
      <div class="hidden md:flex flex-col justify-between bg-[#090446] text-white w-1/6 p-4">
        <!-- Top Menu -->
        <div class="sticky top-0 bg-[#090446] p-4 z-20">
          <div>
            <p class="text-lg font-semibold">Total Progress: {{
                        progressDetail.totalAnswers1}}/{{
                            progressDetail.totalQuestions1}}
            </p>
            <div class="w-full bg-gray-200 rounded-full h-2.5 mt-2">
                <div class="bg-[#ab064e] h-2.5 rounded-full"
                    :style="{ width: ((progressDetail.totalAnswers1) / (progressDetail.totalQuestions1)) * 100 + '%' }">
                </div>
            </div>
          </div>
        </div>
  
        <!-- Bottom Menu -->
        <div class="mt-auto">
          <router-link to="/privacy-policy" class="text-white hover:text-[#ab064e]">
            Privacy Policy
          </router-link>
        </div>
      </div>
  
      <!-- Main Content -->
      <div class="flex-1 flex flex-col items-center py-6 md:px-16 px-4 z-0">
        <!-- Instructions Card -->
        <div id="instructions-card" class="bg-white text-black p-6 rounded-lg shadow-lg mb-6 w-full lg:w-3/4">
          <div class="flex items-center justify-center mb-4">
            <a href="#" class="flex items-center">
              <img src="../assets/images/logo.png" class="h-24" alt="Logo" />
            </a>
          </div>
          <div>
            <p class="text-lg text-black mb-4">
                Thank you for completing the <strong> Change and Ambiguity Assessment</strong>!
            </p>
            <p class="text-lg text-black mb-4">
                We appreciate you taking the time to reflect on your responses. Based on your answers, you'll receive a personalized <strong>report</strong> summarizing your results, including insights on your comfort with ambiguity and how you approach change.
            </p>
            <p class="text-lg text-black mb-4">
                <strong>Next Steps:</strong>
                <ul>
                    <li>• Your report will be delivered to you shortly via email (be sure to check spam).</li>
                    <li>• We encourage you to review the results and consider how they might help you in navigating change.</li>
                </ul>
            </p>
            <p class="text-lg text-black mb-4">If you have any questions or would like to learn more about how to interpret your results, feel free to reach out to admin@mpact-int.com.</p>
          </div>
          
        </div>
      </div>
    </section>
  </template>
  
  
  <script>
  import Swal from 'sweetalert2'
  import Api from '../router/api'
  import AppMixin from '../mixins/AppMixin'
  
  export default {
    name: 'NonEmployeeSurveyTwo',
    data() {
      return {
        url: '',
        questions: [],
        selectedAnswers: {},
        progressDetail: {
          totalQuestions1: 0,
          totalAnswers1: 0,
        }
      }
    },
    mounted() {
      let urlToken = this.$route.fullPath.split('/')[2]
      this.url = urlToken
      this.getProgressBarDetail(this.url)
      this.getQuestions(this.url)
    },
    computed: {
      progress() {
        // Calculate the progress percentage
        return (Object.keys(this.selectedAnswers).length / this.questions.length) * 100;
      }
    },
    methods: {
      getProgressBarDetail(url) {
          Api.getAssessmentProgress(url).then(response => {
              this.progressDetail.totalQuestions1 = response.data.res.totalQuestions1;
              this.progressDetail.totalAnswers1 = response.data.res.totalAnswers1;
          });
      }
    }
  }
  </script>
  
  <style scoped>
  </style>
  


// WEBPACK FOOTER //
// src/components/AssessmentComplete.vue